<template>
  <div class="inline-flex px-4 py-2 text-white rounded text-2sm w-auto">
    <slot/>
  </div>
</template>

<script>
export default {
  name: "BaseBadge",
}
</script>